import moment from 'moment';
import { gettext } from '../../../../../state/gettext-extract-util';
const historyStatus = {
  pending: 'pending', // initiated
  aborted: 'aborted', // not acknowledged
  completed: 'completed', // completed
  rejected: 'rejected', // not acknowledged
  acknowledged: 'acknowledged', // processing
  pendingAbort: 'pending abort', // not acknowledged
};

const mapStatus = (status) => {
  switch (status) {
    case historyStatus.pending:
      return gettext('Initiated');
    case historyStatus.acknowledged:
      return gettext('Processing');
    case historyStatus.completed:
      return gettext('Completed');
    case historyStatus.pendingAbort:
      return gettext('Not Acknowledged');
    case historyStatus.aborted:
      return gettext('Not Acknowledged');
    case historyStatus.rejected:
      return gettext('Failed');
    default:
      return status;
  }
};

const incompleteStatus = [
  historyStatus.pending,
  historyStatus.acknowledged,
  historyStatus.pendingAbort,
];

const updateItem = (updatedItem, list) => {
  const toUpdateIndex = list.findIndex((listItem) => listItem.id === updatedItem.id);

  if (!isNaN(toUpdateIndex) && toUpdateIndex !== -1) {
    list[toUpdateIndex] = {
      ...list[toUpdateIndex],
      status: updatedItem.status,
      statusAt: updatedItem.statusAt,
      uiStatus: mapStatus(updatedItem.status),
    };
  }
};

const setPendingEndTime = (history) => {
  if (incompleteStatus.includes(history.status)) {
    history.expectedEnd = moment(history.createdAt).add(3, 'm').toDate();
  }
};

const setLabel = (history, commands = []) => {
  const command = commands.find((comm) => comm.name === history.name);

  if (command) {
    history.label = command.label;
    const translation = command.parameters.find((param) => param.key === 'translation');
    (command.parameters || [])
      .filter((param) => !param.readOnly)
      .map((p) => {
        history.label =
          history.parameters && history.parameters[p.key]
            ? `${history.label} : ${getvalueLabel(
                history.parameters[p.key],
                translation?.value,
                p.validValues,
              )}`
            : history.label;
      });
  } else {
    history.label = history.name;
  }
};

const getvalueLabel = (value, translationValue, validValue = []) =>
  validValue.find((obj) => obj.value === value)?.label ||
  (translationValue
    ? parseFloat(value) / (parseInt(translationValue) === 0 ? 1 : parseInt(translationValue))
    : value);

const CommandHistoryService = (CommandsRepo, $q) => {
  'ngInject';

  const getHistory = (equipmentId, commands) =>
    CommandsRepo.getEquipmentCommandHistory(equipmentId).then((response = {}) =>
      (response.data || []).map((history) => {
        setPendingEndTime(history);
        setLabel(history, commands);

        return {
          ...history,
          uiStatus: mapStatus(history.status),
        };
      }),
    );

  const updatePending = (historyList) => {
    const promiseList =
      historyList && historyList.length > 0
        ? historyList
            .filter((historyItem) => incompleteStatus.includes(historyItem.status))
            .map((pendingItem) => updatePendingItem(pendingItem, historyList))
        : [];

    return $q.all(promiseList).then(() => historyList);
  };

  const updatePendingItem = (item, historyList) =>
    CommandsRepo.getCommandHistoryItem(item.id).then((result) =>
      updateItem(result.data, historyList),
    );

  return {
    commandHistoryStatus: historyStatus,
    getHistory: getHistory,
    updatePending: updatePending,
  };
};

export default CommandHistoryService;
